import ResetPasswordForm from 'components/modules/auth/ResetPasswordForm';
import { getItemFromStore } from 'helpers/utils';
import AuthCardLayout from 'layouts/AuthCardLayout';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { CHANGE_PASSWORD } from 'services';

const ResetPassword = () => {
  const email = getItemFromStore('forgetPasswordEmail');
  const [token, setToken] = useState<number>();
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [validated, setValidated] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [isSuccessful, setIsSuccessful] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isSuccessful) {
      setIsLoading(false);
      navigate('/');
    }
  }, [isSuccessful]);

  const forgetPassword = useMutation('login', CHANGE_PASSWORD, {
    onSuccess: (data: any) => {
      setIsSuccessful(true);
      const {
        data: { message }
      } = data.data;
      setMessage(message);
    },
    onMutate: () => {
      setIsLoading(true);
    },
    onError: (error: any) => {
      setErrorMessage(error?.response?.data?.message);
      setIsLoading(false);
    }
  });
  const handleSubmit = async (e: any) => {
    try {
      const { form } = e.currentTarget;
      e.preventDefault();
      if (!form.checkValidity()) {
        setValidated(false);
        return;
      }
      await forgetPassword.mutateAsync({
        email,
        token: token as number,
        password,
        confirmPassword
      });
      setValidated(true);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <AuthCardLayout>
      <ResetPasswordForm
        token={token as number}
        password={password}
        confirmPassword={confirmPassword}
        validated={validated}
        errorMessage={errorMessage}
        message={message}
        isLoading={isLoading}
        handleSubmit={handleSubmit}
        setToken={setToken}
        setPassword={setPassword}
        setConfirmPassword={setConfirmPassword}
        setErrorMessage={setErrorMessage}
      />
    </AuthCardLayout>
  );
};

export default ResetPassword;
